export const styles = {
  borderRadius: "0",
  width: "129px",
  height: "54px",
  textTransform: "none",
  margin: "2%",
  marginBottom: "0"
};
